export default __webpack_public_path__ + "static/media/tool-icon-shirt-blue-13.3cbab250.svg";